/* eslint-disable prettier/prettier */

export const getApiBase = () => window.__CONFIG__?.apiServer || "http://localhost";

// Generales
export const token = () =>
  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJodHRwOi8vc2NoZW1hcy54bWxzb2FwLm9y...";

export const LogIn = () => `${getApiBase()}/api/Auth/login`;
export const LogOut = () => `${getApiBase()}/api/Auth/Logout`;
export const ExtenderToken = () => `${getApiBase()}/api/Auth/ExtenderToken`;

// Dashboard
export const getSolicitudesXedad = () => `${getApiBase()}/api/Dashboard/GetSolicitudesPorEdad`;
export const getSolicitudesXentidad = () =>
  `${getApiBase()}/api/Dashboard/GetSolicitudesPorEntidad`;
export const getSolicitudescomoEnteraron = () =>
  `${getApiBase()}/api/Dashboard/GetSolicitudesPorEntero`;
export const getSolicitudesPorSexo = () => `${getApiBase()}/api/Dashboard/GetSolicitudesPorSexo`;
export const getSolicitudesTerapia = () => `${getApiBase()}/api/Dashboard/GetSolicitudesPorTerapia`;
export const getSolicitudesAuditivo = () =>
  `${getApiBase()}/api/Dashboard/GetSolicitudesPorAuxAuditivos`;
export const getResumenSolicitudesExpedientes = () =>
  `${getApiBase()}/api/Dashboard/GetResumenSolicitudesYExpedientes`;
export const getSolicitudesTamizNeoAuditivo = () =>
  `${getApiBase()}/api/Dashboard/GetSolicitudesPorTamizNeoAuditivo`;

// Administración
export const getUsuarios = () => `${getApiBase()}/api/Usuarios/GetUsuarios`;
export const insertUsuario = () => `${getApiBase()}/api/Usuarios/InsertarUsuario`;
export const updateStatusUsuario = () => `${getApiBase()}/api/Usuarios/UpdateStatusUsuario`;
export const deleteUsuario = () => `${getApiBase()}/api/Usuarios/DeleteUsuario/`;
export const updateContrasena = () => `${getApiBase()}/api/Auth/ActualizarPasswordUsuario`;

export const getRoles = () => `${getApiBase()}/api/Roles/GetRoles`;
export const insertRol = () => `${getApiBase()}/api/Roles/InsertarRolUsuario`;
export const updateRol = () => `${getApiBase()}/api/Roles/ActualizarRolUsuario`;
export const updateStatusRol = () => `${getApiBase()}/api/Roles/UpdateStatusRol`;
export const getRolesPermisosYGrupos = () => `${getApiBase()}/api/Roles/GetRolesPermisosYGrupos`;
export const GetRolesByIdRol = () => `${getApiBase()}/api/Roles/GetRolesByIdRol`;
export const ObtenerUsuarioPorId = () => `${getApiBase()}/api/Usuarios/ObtenerUsuarioPorId`;

// Solicitudes
export const getSolicitudes = () => `${getApiBase()}/api/Solicitudes/ObtenerSolicitudes`;
export const getInformacionAdicional = () => `${getApiBase()}/api/Solicitudes/InformacionInicial`;
export const postCreateSolicitud = () => `${getApiBase()}/api/Solicitudes/CreateSolicitud`;
export const postAgregarEstudio = () => `${getApiBase()}/api/Solicitudes/AgregarEstudio`;
export const AgregarDocumentos = () => `${getApiBase()}/api/Solicitudes/AgregarDocumentos`;
export const ValidarSolicitudPorCorreo = () =>
  `${getApiBase()}/api/Solicitudes/ValidarSolicitudPorCorreo`;
export const ObtenerSolicitud = () => `${getApiBase()}/api/Solicitudes/ObtenerSolicitud`;
export const MarcarComoLeida = () => `${getApiBase()}/api/Solicitudes/MarcarComoLeida`;
export const ObtenerSolicitudesExportacion = () =>
  `${getApiBase()}/api/Solicitudes/ObtenerSolicitudesExportacion`;
export const ActualizarEstadoDocumentoSolicitud = () =>
  `${getApiBase()}/api/Solicitudes/ActualizarEstadoDocumentoSolicitud`;
export const ActualizarEstadoDocsReunionBoston = () =>
  `${getApiBase()}/api/Solicitudes/ActualizarEstadoDocsReunionBoston`;
export const ActualizarEstadoDocsReunionNacional = () =>
  `${getApiBase()}/api/Solicitudes/ActualizarEstadoDocsReunionNacional`;
export const ActualizarEstadoDocumentacionClinica = () =>
  `${getApiBase()}/api/Solicitudes/ActualizarEstadoDocumentacionClinica`;
export const ActualizarEstadoEstudioSE = () =>
  `${getApiBase()}/api/Solicitudes/ActualizarEstadoEstudioSE`;

export const AgregarDocumentacionAdministrativa = () =>
  `${getApiBase()}/api/Solicitudes/AgregarDocumentacionAdministrativa`;
export const ObtenerDocumentacionCompletaArchivos = () =>
  `${getApiBase()}/api/Solicitudes/ObtenerDocumentacionCompleta`;
export const EliminarDocumentoPorTabla = () =>
  `${getApiBase()}/api/Solicitudes/EliminarDocumentoPorTabla`;
export const ActualizarObservacionSolicitud = () =>
  `${getApiBase()}/api/Solicitudes/ActualizarObservacionSolicitud`;
export const AgregarDocumentoPorTabla = () =>
  `${getApiBase()}/api/Solicitudes/AgregarDocumentoPorTabla`;

export const ActualizarSolicitudAExpediente = () =>
  `${getApiBase()}/api/Solicitudes/ActualizarSolicitudAExpediente`;
export const UpdateSolicitud = () => `${getApiBase()}/api/Solicitudes/UpdateSolicitud`;

// Intentos de solicitud
export const GetAllIntentosSolicitud = () =>
  `${getApiBase()}/api/IntentosSolicitud/GetAllIntentosSolicitud`;
export const InsertIntentosSolicitud = () =>
  `${getApiBase()}/api/IntentosSolicitud/InsertIntentosSolicitud`;
export const CambiarEstatusBorradoSolicitud = () =>
  `${getApiBase()}/api/Solicitudes/CambiarEstatusBorradoSolicitud`;
export const ObtenerSolicitudesBorradas = () =>
  `${getApiBase()}/api/Solicitudes/ObtenerSolicitudesBorradas`;

// Expedientes

// Citas TAV
export const InsertarCita = () => `${getApiBase()}/api/Citas/AgregarCita`;
export const NotificarPaciente = () => `${getApiBase()}/api/Citas/NotificarPaciente`;
export const NotificarMedico = () => `${getApiBase()}/api/Citas/NotificarMedicosPorSolicitud`;
export const GetDocumentosCita = () => `${getApiBase()}/api/Citas/ObtenerDocumentosPorCita`;
export const GetAllCitas = () => `${getApiBase()}/api/Citas/ObtenerTodasLasCitas`;
export const GetCitasProximas = () => `${getApiBase()}/api/Citas/ObtenerProximasCitas`;
export const GetCitasAnteriores = () => `${getApiBase()}/api/Citas/ObtenerAnterioresCitas`;
export const GetCitasSolicitud = () => `${getApiBase()}/api/Citas/ObtenerCitasPorSolicitud`;
export const CargarDocumentoCita = () => `${getApiBase()}/api/Citas/CargarDocumentoCita`;
export const DeleteCita = () => `${getApiBase()}/api/Citas/EliminarCita`;

// Citas
export const GetAllCitasSolicitud = () => `${getApiBase()}/api/Citas/ObtenerCitasPorSolicitud`;

// Catálogos
export const GetAllServiciosMedicos = () =>
  `${getApiBase()}/api/ServiciosMedicos/GetAllServiciosMedicos`;
export const GetAllParentesco = () => `${getApiBase()}/api/Parentesco/GetAllParentesco`;
export const GetAllHospitales = () => `${getApiBase()}/api/Hospitales/GetAllHospitales`;
export const GetAllEstudios = () => `${getApiBase()}/api/EstudiosMedicos/GetAllEstudios`;
export const GetAllCatalogos = () => `${getApiBase()}/api/Catalogos/GetAllCatalogos`;
export const GetAllCorreos = () =>
  `${getApiBase()}/api/DestinatariosCorreo/GetAllDestinatariosCorreo`;
export const GetMedicos = () => `${getApiBase()}/api/Catalogos/GetMedicos`;

export const InsertHospital = () => `${getApiBase()}/api/Hospitales/InsertHospital`;
export const InsertParentesco = () => `${getApiBase()}/api/Parentesco/InsertParentesco`;
export const InsertServiciosMedicos = () =>
  `${getApiBase()}/api/ServiciosMedicos/InsertServiciosMedicos`;
export const InsertEstudio = () => `${getApiBase()}/api/EstudiosMedicos/InsertEstudio`;
export const InsertCorreo = () =>
  `${getApiBase()}/api/DestinatariosCorreo/InsertDestinatariosCorreo`;

export const UpdateServiciosMedicos = () =>
  `${getApiBase()}/api/ServiciosMedicos/UpdateServiciosMedicos`;
export const UpdateParentesco = () => `${getApiBase()}/api/Parentesco/UpdateParentesco`;
export const UpdateHospital = () => `${getApiBase()}/api/Hospitales/UpdateHospital`;
export const UpdateEstudio = () => `${getApiBase()}/api/EstudiosMedicos/UpdateEstudio`;
export const UpdateCorreo = () =>
  `${getApiBase()}/api/DestinatariosCorreo/UpdateDestinatariosCorreo`;
export const CambiarContrasena = () => `${getApiBase()}/api/Usuarios/CambiarContrasena`;
export const ResetearPasswordUsuario = () => `${getApiBase()}/api/Usuarios/ResetearPasswordUsuario`;

// Notificaciones
export const ContarNotificacionesNoLeidas = () =>
  `${getApiBase()}/api/Notificaciones/ContarNotificacionesNoLeidas`;
export const GetNotificacionesPorSolicitud = () =>
  `${getApiBase()}/api/Notificaciones/GetNotificacionesPorSolicitud`;
export const MarcarNotificacionesComoLeidasPorSolicitud = () =>
  `${getApiBase()}/api/Notificaciones/MarcarNotificacionesComoLeidasPorSolicitud`;
export const GetNotificacionesPendientesSeparadas = () =>
  `${getApiBase()}/api/Notificaciones/GetNotificacionesPendientesSeparadas`;

// Descargas
export const DescargarArchivoDocumentacionClinica = () =>
  `${getApiBase()}/api/Archivos/DescargarArchivoDocumentacionClinica`;
export const DescargarArchivoGeneral = () => `${getApiBase()}/api/Archivos/DescargarArchivoGeneral`;
export const DescargarZip = () => `${getApiBase()}/api/Archivos/DescargarZipPorSolicitud`;

// Galería
export const GetGaleria = () => `${getApiBase()}/api/Galeria/GetGaleriaPorSolicitud`;
export const InsertGaleria = () => `${getApiBase()}/api/Galeria/InsertGaleria`;
export const EliminarGaleria = () => `${getApiBase()}/api/Galeria/EliminarGaleria`;
